import React from 'react';
import './CSS/WhyFixinn.css';

// Import images
import settingsIcon from '../assets/images/settings.png';
import tickIcon from '../assets/images/tick.png';
import timerIcon from '../assets/images/timer.png';
import personIcon from '../assets/images/person.png';
import girlImage from '../assets/images/girl1.png';

const WhyFixinn = () => {
  const features = [
    {
      icon: settingsIcon,
      title: "Experienced Professionals",
      description: "Our team is skilled and certified in various service areas."
    },
    {
      icon: tickIcon,
      title: "Customer-Centric Approach",
      description: "We prioritize your satisfaction and convenience."
    },
    {
      icon: timerIcon,
      title: "Quick Turnaround",
      description: "Efficient service delivery without compromising quality."
    },
    {
      icon: personIcon,
      title: "Personalized Service",
      description: "Every customer gets tailored attention and honest advice."
    }
  ];

  return (
    <section className="why-fixinn-section">
      <div className="container">
        <div className="why-fixinn-content">
          {/* Left Column */}
          <div className="why-fixinn-left">
            <div className="why-fixinn-header">
              <h2 className="why-fixinn-title">
                Why <span className="text-primary">fixINN</span>? Because
                You Deserve <span className="text-primary">Better Service.</span>
              </h2>
              <p className="why-fixinn-description">
                At fixINN, we combine expert hands, personalized care, and fast
                turnaround — so your devices, routines, and lifestyle stay stress-free.
              </p>
            </div>

            <div className="why-fixinn-features">
              {features.map((feature, index) => (
                <div key={index} className="feature-item">
                  <div className="feature-icon">
                    <img src={feature.icon} alt={feature.title} />
                  </div>
                  <div className="feature-content">
                    <h3 className="feature-title">{feature.title}</h3>
                    <p className="feature-description">{feature.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right Column */}
          <div className="why-fixinn-right">
            <div className="why-fixinn-girl-wrapper">
              <img src={girlImage} alt="Happy customer with phone" className="why-fixinn-girl-image" />
              <div className="ellipse-background"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyFixinn;
